import React from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { PROJECT_WEBSITE_URL } from 'config.jsx';
import Logo from 'images/logo.gif';
import AccountAndRecents from './AccountAndRecents';

const styles = theme => ({
  InfoBar: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.primary.main,
    alignItems: 'center',
  },
  sideItem: {
    width: '280px',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '115px',
    },
  },
  Logo: {
    height: '5rem',
  },
  ElephantInfo: {
    flexGrow: '1',
    padding: '5px',
    textAlign: 'center',
  },
  ElephantInfoTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.7rem',
    },
  },
  ElephantInfoSub: {
    display: 'inline-block',
    marginLeft: '6px',
    marginRight: '6px',
  },
});

export const InfoBar = (props) => {
  const {
    elephant,
    classes,
    recentsClick,
  } = props;

  return (
    <div className={classes.InfoBar}>
      <div className={classes.sideItem} style={{ textAlign: 'left' }}>
        <a href={PROJECT_WEBSITE_URL} target="_blank" rel="noopener noreferrer">
          <img src={Logo} className={classes.Logo} alt={`Link to ${PROJECT_WEBSITE_URL}`} />
        </a>
      </div>

      <div className={classes.ElephantInfo}>
        {
          elephant
            && (
            <React.Fragment>
              <Typography className={classes.ElephantInfoTitle} variant="display1" color="secondary">
                {elephant.name || 'No name'}
              </Typography>
              <div>
                <Typography className={classes.ElephantInfoSub} color="secondary">
                  {elephant.num || 'No MTE number'}
                </Typography>
                <Typography className={classes.ElephantInfoSub} color="secondary">
                  {`${elephant.birth ? moment(elephant.birth).format() : 'Unknown birthday'}`}
                </Typography>
                {
                  (elephant.cw === 'captive' || elephant.cw === ' wild') && (
                  <Typography className={classes.ElephantInfoSub} color="secondary">
                    {`Born ${elephant.cw}`}
                  </Typography>
                  )
                }
              </div>
            </React.Fragment>
            )
        }
      </div>
      <div className={classes.sideItem}>
        <AccountAndRecents elephant={elephant} updateActiveElephant={recentsClick} />
      </div>
    </div>
  );
};

InfoBar.defaultProps = {
  elephant: {},
};


InfoBar.propTypes = {
  elephant: PropTypes.shape(),
  classes: PropTypes.shape().isRequired,
  recentsClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(InfoBar);



// WEBPACK FOOTER //
// ./src/layout/top-panel/InfoBar.jsx